import React from "react";
import { useForm } from "react-hook-form";
import { DegreeTypeListProps, DegreeTypes } from "./DegreeTypeList.types";

const DegreeTypeList = (props: DegreeTypeListProps) => {
    const { handleSubmit, register, reset } = useForm<DegreeTypes>();

    const submitDegreeTypes = (formData) => {
        props.onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit(submitDegreeTypes)}>
            <div className="form-group">
                <div>
                    <label htmlFor="degreeDiploma">Diploma</label>
                </div>
                <div>
                    <label className="checkbox-container">
                        <input
                            type="checkbox"
                            name="degreeDiploma"
                            ref={register()}
                            defaultChecked={
                                props.selectedDegreeTypes.degreeDiploma
                            }
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </div>
            <div className="form-group">
                <div>
                    <label htmlFor="degreeCertificate">Certificate</label>
                </div>
                <div>
                    <label className="checkbox-container">
                        <input
                            type="checkbox"
                            name="degreeCertificate"
                            ref={register()}
                            defaultChecked={
                                props.selectedDegreeTypes.degreeCertificate
                            }
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </div>
            <div className="form-group">
                <div>
                    <label htmlFor="degreeAssociate">Associate</label>
                </div>
                <div>
                    <label className="checkbox-container">
                        <input
                            type="checkbox"
                            name="degreeAssociate"
                            ref={register()}
                            defaultChecked={
                                props.selectedDegreeTypes.degreeAssociate
                            }
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </div>
            <div className="form-group">
                <div>
                    <label htmlFor="degreeBaccalaureate">Baccalaureate</label>
                </div>
                <div>
                    <label className="checkbox-container">
                        <input
                            type="checkbox"
                            name="degreeBaccalaureate"
                            ref={register()}
                            defaultChecked={
                                props.selectedDegreeTypes.degreeBaccalaureate
                            }
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </div>
            <div className="form-group">
                <div>
                    <label htmlFor="degreeMasters">Masters</label>
                </div>
                <div>
                    <label className="checkbox-container">
                        <input
                            type="checkbox"
                            name="degreeMasters"
                            ref={register()}
                            defaultChecked={
                                props.selectedDegreeTypes.degreeMasters
                            }
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </div>
            <div className="button-footer">
                <div>
                    <button
                        type="button"
                        className="clear-btn"
                        onClick={() =>
                            reset({
                                degreeAssociate: false,
                                degreeBaccalaureate: false,
                                degreeCertificate: false,
                                degreeDiploma: false,
                                degreeMasters: false,
                            })
                        }
                    >
                        Clear All
                    </button>
                </div>
                <div>
                    <button type="submit" className="submit-btn">
                        Search
                    </button>
                </div>
            </div>
        </form>
    );
};

export default DegreeTypeList;
